import { create } from 'zustand';

type ModalType = 'createUser' | 'editUser' | 'confirm';

interface ModalData {
  type: ModalType;
  props?: any;
}

interface ModalStore {
  modal: ModalData | null;
  openModal: (type: ModalType, props?: any) => void;
  closeModal: () => void;
}

export const useModal = create<ModalStore>((set) => ({
  modal: null,
  openModal: (type, props) => set({ modal: { type, props } }),
  closeModal: () => set({ modal: null }),
}));